import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  .page-bg-image {
    background: linear-gradient(
      180deg,
      #460a42 0%,
      #000 25%,
      #000 70%,
      #1f0650 100%
    );
  }

  .bg-image {
    width: 100%;
    height: 100%;
    position: relative;

    .bg-image-rotate {
      width: 620px;
      aspect-ratio: 0.7;
      transform: rotate(15deg) translate(-50%, 0);
      position: absolute;
      top: -100px;
      left: 50%;
      z-index: 1;

      @media screen and (min-width: 500px) {
        width: 700px;
      }

      .bg-image-img {
        width: 100%;
        height: 100%;
      }
    }

    .overlay-gradient {
      width: 100%;
      height: 70%;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      display: block;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        #010101 50%,
        #220854 100%
      );
    }
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }

    .app-logo {
      margin: 0 0 30px;
    }
  }

  #root .ion-page & {
    ion-footer {
      padding: 16px 16px 32px;

      .page-footer-button {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        border-radius: 12px;
        box-shadow: 0px 0px 34px 0px rgba(128, 62, 255, 0.5);
      }
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    margin: 0 0 20px;
    font-weight: 600;
  }
`;
